import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { cloneDeep } from 'lodash';
import {
  accumulateSchema,
  accumulateSchemaToNexsetSampleDraft,
  updateNexsetSampleDraft,
} from 'js/actions';
import useRequests from 'new/state/request/repository/useRequests';
import type { DataSet } from '../types';

export const useNexsetSample = () => {
  const dispatch: ThunkDispatch<{}, unknown, AnyAction> = useDispatch();
  const { showError } = useRequests();
  const [selectedNexset, setSelectedNexset] = useState<DataSet | null>(null);

  const handleSelect = ({ name, id, samples }: DataSet) => {
    if (selectedNexset?.id === id) {
      setSelectedNexset(null);
      return;
    }

    setSelectedNexset({ name, id, samples });
  };

  const handleLoadSamples = async (inputSamples) => {
    const parsedSamples = JSON.parse(inputSamples || '');

    try {
      const schemaAccumulation = await dispatch(accumulateSchema(parsedSamples));

      const samplesDataWithAttrs = [
        {
          attrs: { ...cloneDeep(parsedSamples) },
          meta: [],
          error: null,
        },
      ];
      const rawSamplesData = [{ ...cloneDeep(parsedSamples) }];

      dispatch(
        updateNexsetSampleDraft({
          name: selectedNexset?.name || '',
          samples: samplesDataWithAttrs,
          rawSamples: rawSamplesData,
        }),
      );

      if (schemaAccumulation) {
        dispatch(accumulateSchemaToNexsetSampleDraft(schemaAccumulation));
      }
    } catch {
      showError('Failed generate schema for samples');
    }
  };

  return {
    selectedNexset,
    handleSelect,
    handleLoadSamples,
  };
};
